// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bht_vu bht_ql bht_va bht_gy bht_kg bht_sv","ProfileAdminTools__item":"iz_b"};